const GA_MEASUREMENT_ID = String(import.meta.env?.VITE_GA_MEASUREMENT_ID || "G-339EH9JK5H").trim();

let initialized = false;

function appendGoogleTagScript() {
  if (typeof document === "undefined") return;
  if (document.getElementById("ga4-gtag-script")) return;

  const script = document.createElement("script");
  script.id = "ga4-gtag-script";
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(GA_MEASUREMENT_ID)}`;
  document.head.appendChild(script);
}

export function initGoogleAnalytics() {
  if (initialized) return;
  if (typeof window === "undefined") return;
  if (!GA_MEASUREMENT_ID) return;

  appendGoogleTagScript();

  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function gtag() {
    window.dataLayer.push(arguments);
  };

  window.gtag("js", new Date());
  window.gtag("config", GA_MEASUREMENT_ID, { send_page_view: false });

  initialized = true;
}

export function trackPageView(pathname) {
  if (!initialized || typeof window === "undefined") return;
  if (!GA_MEASUREMENT_ID) return;

  window.gtag("event", "page_view", {
    page_path: pathname || window.location.pathname,
    page_location: window.location.href,
    page_title: document?.title || "",
  });
}
